<app-header></app-header>
  <div class="image-container">
    <img src="assets/navimage.png" width="100%" alt="Your Image">
    <div class="image-text">
      <p>Admissions</p>
    </div>
  </div> 
  <div class="bg-white" style="height: 10vh;"></div>

  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mx-2 align-items-center">description</mat-icon>
        Admission Form
      </ng-template>
     <div class="container mt-5 pb-4">
        <div class="row">
           <div class="col-lg-12 col-md-12 col-sm-12 px-4">
              <div class="text-center head_font">
                <span>Fill Enquiry form to get back from Us!</span>
              </div>
              <div class="row mt-3">
                <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2" > 
                  <label for="inputField"><b>Name</b> </label>
                  <input type="text" id="inputField" name="inputField" class="white-border">
                </div>
        
                <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2"> 
                  <label for="inputField"><b>Email</b> </label>
                  <input type="text" id="email" name="inputField" class="white-border">
                </div>
              </div>

              <div class="row mt-2">
                <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2" > 
                  <label for="inputField"><b>Phone</b> </label>
                  <input type="text" id="phone" name="inputField" class="white-border">
                </div>
        
                <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2">
                    <label for="class"><b>Class</b> </label>
                    <select id="class" name="class" class="white-border" style="border-radius: 5px;">
                        <option value="">Select a class</option>
                        <option value="1">Class 1</option>
                        <option value="2">Class 2</option>
                        <option value="3">Class 3</option>
                        <option value="4">Class 4</option>
                        <option value="5">Class 5</option>
                        <option value="6">Class 6</option>
                        <option value="7">Class 7</option>
                        <option value="8">Class 8</option>
                        <option value="9">Class 9</option>
                        <option value="10">Class 10</option>
                    </select>
                </div>
                
              </div>
        
              <div class="row mt-4">
                <div class="d-flex flex-column col-lg-12 col-md-6 col-sm-6 px-2"> 
                  <label for="inputField"><b>Description</b> </label>
                  <textarea id="messageField" name="messageField" class="white-border1" rows="4"></textarea>
                </div>
              </div>
             
              <div class="mt-4 text-center">
                <button mat-button style="background-color: #0A146E; color: #fff;">Send Message</button>
              </div>

           </div>
        </div>
     </div>
     
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="align-items-center">label_important</mat-icon>
        <mat-icon class=" align-items-center">label_important</mat-icon>
        <mat-icon class="align-items-center">label_important</mat-icon>
        <span class="mx-2">Admission Process and Criteria</span> 
      </ng-template>
      <div class="container mt-5 pb-4">
        <div class="row">
            <div class="col-lg-12 col-sm-12 ">
                <div class="brdr_btm">
                    <span class="content3">A. CRITERIA </span>
                </div>
                <div>
                    <table mat-table [dataSource]="dataSource1" class="mt-4 mat-table">

                        <ng-container matColumnDef="slno">
                          <th mat-header-cell *matHeaderCellDef>S. No. </th>
                          <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                        </ng-container>
                      
                        <ng-container matColumnDef="class">
                          <th mat-header-cell *matHeaderCellDef > CLASS </th>
                          <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.class}} </td>
                        </ng-container>
                      
                        <ng-container matColumnDef="criteria">
                          <th mat-header-cell *matHeaderCellDef> CRITERIA </th>
                          <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.criteria}} </td>
                        </ng-container>
                      
                      
                        <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns1;" ></tr>
                        
                      </table>
                </div>
                <div class="brdr_btm">
                    <span class="content3">B. ADMISSION PROCESS </span>
                </div>

                <div class="content2">Admission procedures in CBSE Schools are on a first-come-first-served basis and seats are limited. Admissions will only be confirmed once the necessary documents and the first-term fee payment is made. Fees once paid will be strictly non-refundable.</div>
                 <div class="d-flex mt-2 align-items-center">
                    <span><img src="assets/arrow.svg" alt=""><img src="assets/arrow1.svg" alt=""><img src="assets/arrow1.svg" alt="">
                    <span class="step mx-2">Step 1</span></span>
                 </div>


                 <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header"  id="panelsStayOpen-headingOne">
                        <button class="accordion-button" style="background-color:#E9E9E9;box-shadow: none;" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                           <img src="assets/bluetick.svg" alt=""> <span class="accord_head">Keep these documents ready</span> 
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                        <div class="accordion-body">
                            <ul class="content2 mt-2">
                                <li>Birth certificate issued by the authority competent to register birth for class I.</li>
                                <li>Aadhar Card, Passport Size photograph of the student</li>
                                <li>Transfer certificate issued by the school last attended if class II and onwards.</li>
                                <li>Category certificates of the candidates of SC/ST/EWS/ OBC-NCL/ BPL categories issued by the competent authority.</li>
                                <li>Proof of Residence, Photocopy of Address proof and Parent's Pan Card.</li>
                                <li>A service certificate showing no. of transfers during the period of 7 years duly signed and stamped by the head of the office bearing the name, and designation.</li>
                            </ul> 
                        </div>
                      </div>
                    </div>
                 </div>

                 <div class="d-flex mt-2 align-items-center">
                    <span><img src="assets/arrow.svg" alt=""><img src="assets/arrow1.svg" alt=""><img src="assets/arrow1.svg" alt="">
                    <span class="step mx-2">Step 2</span></span>
                 </div>
                 <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header"  id="panelsStayOpen-headingOne">
                        <button class="accordion-button " style="background-color:#E9E9E9;box-shadow: none;" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                           <img src="assets/bluetick.svg" alt=""> <span class="accord_head">Fill out the registration form</span> 
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                        <div class="accordion-body">
                            <ul class="content2 mt-2">
                                <li>The Registration Form consists of all the information on the Selection Criteria and Documents Required for the admission procedure in CBSE Schools. Fill out the registration form carefully and attach all the necessary documents.</li>
                            </ul> 
                        </div>
                      </div>
                    </div>
                  </div>
                  
                 <div class="d-flex mt-2 align-items-center">
                    <span><img src="assets/arrow.svg" alt=""><img src="assets/arrow1.svg" alt=""><img src="assets/arrow1.svg" alt="">
                    <span class="step mx-2">Step 3</span></span>
                 </div>
                 <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header"  id="panelsStayOpen-headingThree">
                        <button class="accordion-button" style="background-color:#E9E9E9;box-shadow: none;" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                           <img src="assets/bluetick.svg" alt=""> <span class="accord_head">Submit the registration form </span> 
                        </button>
                      </h2>
                      <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                        <div class="accordion-body">
                            <ul class="content2 mt-2">
                                <li>After filling out the school admission form and attaching the required documents, kindly submit the same at your nearest senior secondary school where you wish to enroll your child.</li>
                            </ul> 
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
      </div>
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mx-2 align-items-center">receipt</mat-icon>
        Fee and Rules
      </ng-template>
    <div class="container mt-5 pb-4">
        <div class="row">
            <div class="col-lg-12 col-sm-12 ">
                <div class="brdr_btm">
                    <span class="content3">A. Fee Rules </span>
                </div>
                <ul class="list mt-2">
                    <li>Registration, Administration, Prospectus and Event/Sports fees are non-refundable.</li>
                    <!-- <li>There will be a minimum increase of 10% in tuition fees annually.</li> -->
                    <li>Tuition fee is payable as per schedule given by school.</li>
                    <li>No reduction/concession in fees is allowed on account of joining late or absence from the school.</li>
                    <li>Fees are charged from the beginning of the Session.</li>
                    <li>Fees are levied for the whole academic year (12 months) and are to be paid.</li>
                    <li>In case of non-compliance in paying the school fees on or before the prescribed date, the name of the student will be removed from the student register at the end of thirty days. Students will only be re-admitted after payment of all dues along with fine and reactivation fee.</li>
                    <li>Students having fee arrears at the time of examination will not be allowed to appear for the examination.</li>
                    <li>In case of withdrawal, parents have to submit one month's prior notice in writing to the school.</li>
                    <li>School leaving certificate or transfer certificate will be issued only after all dues are cleared.</li>
                  </ul> 
                  <div class="brdr_btm">
                    <span class="content3">B. Fees </span>
                  </div>
                  <div class="fee-struct">
                    <img src="assets/fee-structure.png" alt="Fee Structure" class="fee-image" />
                  </div>


             <!-- <table mat-table [dataSource]="dataSource" class="mt-4 mat-table">

                    <ng-container matColumnDef="slno">
                      <th mat-header-cell *matHeaderCellDef>S. No. </th>
                      <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                    </ng-container>
                  
                    <ng-container matColumnDef="class">
                      <th mat-header-cell *matHeaderCellDef > CLASS </th>
                      <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.class}} </td>
                    </ng-container>
                  
                    <ng-container matColumnDef="fees">
                      <th mat-header-cell *matHeaderCellDef class="text-center"> FEES </th>
                      <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.fees}} </td>
                    </ng-container>
                  
                  
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
                    
                  </table>  -->
                  
                  

            </div>
        </div>
    </div>
    </mat-tab>
  </mat-tab-group>

  <app-footer></app-footer>
  <!-- <mat-tab-group color="accent" backgroundColor="primary">
    <mat-tab label="First">Content 1</mat-tab>
    <mat-tab label="Second">Content 2</mat-tab>
    <mat-tab label="Third">Content 3</mat-tab>
  </mat-tab-group> -->